// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2jK6i","toggleWrap":"styles_toggleWrap__2iCdA","content":"styles_content__1B0SZ","selectAreaCode":"styles_selectAreaCode__HiLc1"};